<!-- Social Platform Analytics Dashboard -->
<ng-container>
  <div [class.hidden]="!_breakpointService.isDesktop()">
    <div class="w-full relative">
      <!-- 🔹 AI Headlines — page-level chrome, hidden in embedded (mixedMode)
          dashboard tiles. -->

      @if (!mixedMode()) {
      <ai-headlines class="block mb-4"></ai-headlines>
      }
      <!-- 🔹 Page header: page title + Add Stats + Customize Layout. -->
      @if (!mixedMode()) {
      <div class="card-bg rounded-xl p-4 mt-2 z-25">
        <div class="flex flex-col lg:flex-row justify-between lg:items-center gap-4 [@media(max-height:620px)]:gap-2">
          <h1 class="text-xl font-medium text-[#141437] dark:text-white [@media(max-height:620px)]:text-lg">
            Social Platform Analytics
          </h1>

          <div
            class="flex flex-wrap items-center gap-2 sm:gap-3 w-full lg:w-auto justify-end [@media(max-height:620px)]:gap-2">
            @if (!mixedMode()) {
            <app-normal-date-picker (dateRangeChange)="onDateRangeFilter($event)" [showComparison]="false"
              [showGroupBy]="true" [predefinedRangesDataSets]="predefinedRanges"
              [selectedStartRange]="selectedStartRange" [selectedEndRange]="selectedEndRange" [hideWeekDayUnit]="true"
              [hideRightSection]="true" [selectedPresetLabel]="'Last 90 Days'">
            </app-normal-date-picker>
            }
            <app-button variant="default" (buttonClick)="openPanel()" [iconName]="'circlePlus'"
              className="flex items-center justify-center gap-2 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_4px_8px_-4px_#AD46FF] transition-all bg-[#AD46FF] hover:bg-[#AD46FF] border-none text-white whitespace-nowrap [@media(max-height:620px)]:!h-8 [@media(max-height:620px)]:!px-3 [@media(max-height:620px)]:!py-0 [@media(max-height:620px)]:!text-xs">
              <span class="font-medium whitespace-nowrap hidden sm:inline">Add Stats</span>
              <span class="font-medium sm:hidden">Add</span>
            </app-button>
            <button (click)="openCustomizeLayout()"
              class="flex items-center gap-1.5 px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm font-medium hover:border-[#AD46FF]/60 hover:text-[#AD46FF] transition-all duration-200 shadow-sm whitespace-nowrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="7" height="7" x="3" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="3" rx="1" />
                <rect width="7" height="7" x="14" y="14" rx="1" />
                <rect width="7" height="7" x="3" y="14" rx="1" />
              </svg>
              Customize layout
            </button>
          </div>
        </div>
      </div>
      }
      <!-- Analytics / Table view toggle — page-level chrome. Hidden in
          `mixedMode` so that every pinned Social Platform widget rendered
          inside My Dashboard doesn't repeat its own view-toggle bar above
          each tile. -->


      @if (!mixedMode()) {
      <div class="flex justify-end mt-4">
        <app-toggle-btns [headerOptions]="{
            showlabels: true,
            showIcon: true,
            showToggleButton: true,
            toggleOptions: tabOptions
          }" [bgColor]="'#2a2a5714'" (viewChanged)="setActiveTab($event)">
        </app-toggle-btns>
      </div>
      }

      <!-- 🔹 Customizable 12-col grid (analytics view).
          Cards are rendered in the persisted order with the persisted
          col-span; visibility, width, and order are all controlled from
          the Customize Layout popup and applied via `applyLayoutEditor()`. -->
      @if(view === 'analyticsView'){
      <div class="grid grid-cols-12 gap-4 mt-4 grid-flow-row-dense">
        @for (sec of embeddedVisibleSections(); track trackSection($index, sec)) {
        <div [ngClass]="getSectionColClass(sec)" class="group relative">

          @if (canPinToCustomDashboard(sec) && !mixedMode()) {
          <button type="button" (click)="addToCustomDashboard(sec); $event.stopPropagation()"
            [disabled]="isAddingToCustomDashboard(sec)"
            class="group/pin absolute cursor-pointer top-2 right-2 z-20 inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full border shadow-sm text-[11px] font-medium whitespace-nowrap opacity-0 translate-y-[-2px] group-hover:opacity-100 group-hover:translate-y-0 focus-visible:opacity-100 focus-visible:translate-y-0 transition-all duration-200 disabled:cursor-default"
            [ngClass]="isAddedToCustomDashboard(sec)
                    ? 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-rose-50 hover:text-rose-700 hover:border-rose-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800 dark:hover:bg-rose-900/30 dark:hover:text-rose-300 dark:hover:border-rose-800 !opacity-100 !translate-y-0'
                    : 'bg-white/95 text-[#AD46FF] border-[#AD46FF]/30 hover:bg-violet-50 hover:border-[#AD46FF]/60 hover:shadow-md dark:bg-slate-800/95 dark:border-purple-500/40 dark:hover:bg-white/5'"
            [attr.aria-label]="isAddedToCustomDashboard(sec) ? 'Remove from My Custom Dashboard' : 'Add to My Custom Dashboard'"
            [title]="isAddedToCustomDashboard(sec) ? 'Click to remove from My Custom Dashboard' : 'Add to My Custom Dashboard'">
            @if (isAddingToCustomDashboard(sec)) {
            <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12a9 9 0 1 1-6.219-8.56" />
            </svg>
            <span>{{ isAddedToCustomDashboard(sec) ? 'Removing' : 'Adding' }}&hellip;</span>
            } @else if (isAddedToCustomDashboard(sec)) {
            <svg class="shrink-0 block group-hover/pin:hidden" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <svg class="shrink-0 hidden group-hover/pin:block" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M5 12h14" />
            </svg>
            <span
              class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[220px] group-hover/pin:ml-0 focus-visible:max-w-[220px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Remove
              from Custom Dashboard</span>
            } @else {
            <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            <span
              class="inline-block max-w-0 -ml-1.5 group-hover/pin:max-w-[200px] group-hover/pin:ml-0 focus-visible:max-w-[200px] focus-visible:ml-0 overflow-hidden whitespace-nowrap transition-all duration-300 ease-out">Pin
              to Custom Dashboard</span>
            }
          </button>
          }

          @switch (sec.id) {

          <!-- ▸ Overall Stats Cards -->
          @case (SectionId.OVERALL_STATS) {
          <div class="card-bg rounded-xl p-4 h-full">
            <div
              class="text-xl font-medium text-[#141437] dark:text-white [@media(max-height:620px)]:text-lg mb-4 [@media(max-height:620px)]:mb-3">
              Overall Performance Details
            </div>

            <div
              [ngClass]="sec.colSpan === 4
                  ? 'grid grid-cols-1 sm:grid-cols-2 gap-4 xl:gap-3 [@media(max-height:620px)]:gap-2 relative'
                  : (sec.colSpan === 6 ? 'grid grid-cols-1 sm:grid-cols-3 gap-4 xl:gap-3 [@media(max-height:620px)]:gap-2 relative' : 'grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 grid-cols-1 gap-4 xl:gap-3 [@media(max-height:620px)]:gap-2 relative')">
              @if(isOverallLoading()){
              <div class="h-[135px] shadow-sm rounded-xl flex items-center justify-center">
                <app-individual-toaster></app-individual-toaster>
              </div>
              }
              @if(!isOverallLoading() && cardStatsConfig().length > 0){
              @for(stat of cardStatsConfig(); track $index){
              <div [style.background]="stat.bg"
                class="rounded-xl p-4 xl:p-3 [@media(max-height:620px)]:p-2.5 text-[#FFFFFF] hover:-translate-y-1 duration-300 relative">
                <button class="p-2 rounded-lg bg-[#FFFFFF33]">
                  <app-icon [size]="18" [name]="stat.icon"></app-icon>
                </button>
                <div
                  class="flex flex-col gap-2 xl:gap-1.5 [@media(max-height:620px)]:gap-1 mt-2 xl:mt-1 [@media(max-height:620px)]:mt-1">
                  <span class="font-normal text-sm xl:text-[11px] xl:leading-tight xl:whitespace-nowrap">{{ stat.label
                    }}</span>
                  <span class="text-2xl xl:text-xl [@media(max-height:620px)]:text-xl font-medium">
                    {{ stat.count | number:(stat.label.includes('Watch Time') ? '1.2-2' : '1.0-0') }}
                  </span>
                </div>
              </div>
              }
              }
            </div>
          </div>
          }

          <!-- ▸ Platform Performance Details -->
          @case (SectionId.PLATFORM_PERFORMANCE) {
          <div class="card-bg rounded-xl p-4 h-full">
            <div class="flex flex-wrap gap-2 items-center justify-between">
              <div class="text-[#141437] text-xl dark:text-white font-medium">
                Platform Performance Details
              </div>
              <!-- @if (mixedMode()) {
              <app-button variant="default" (buttonClick)="openPanel()" [iconName]="'circlePlus'"
                className="flex items-center justify-center gap-2 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_4px_8px_-4px_#AD46FF] transition-all bg-[#AD46FF] hover:bg-[#AD46FF] border-none text-white whitespace-nowrap !h-8 !px-3 !py-0 !text-xs">
                <span class="font-medium whitespace-nowrap hidden sm:inline">Add Stats</span>
                <span class="font-medium sm:hidden">Add</span>
              </app-button>
              } -->
            </div>

            @if (!isPlatformWiseLoading() && visibleStats()?.length > 0) {
            <div (scroll)="onScroll($event)" class="pr-2 mt-4 w-full">

              <div [ngClass]="sec.colSpan === 4
                    ? 'grid grid-cols-1 gap-4 mt-4'
                    : (sec.colSpan === 6
                        ? 'grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4'
                        : (sec.colSpan === 8
                            ? 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-4'
                            : 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4'))">
                @for (item of visibleStats(); track $index) {
                <div
                  class="bg-white border border-[#EAEAEA] backdrop-blur-xl dark:bg-surface-1 dark:border-line shadow-sm transition-all rounded-2xl p-4 xl:p-3 [@media(max-height:620px)]:p-2.5 overflow-hidden dark:hover:border-line-strong hover:border-slate-300 relative">
                  <!-- NAME SECTION -->
                  <div class="flex gap-2 items-center justify-between relative">
                    <div class="flex items-center gap-2" [style.color]="
                          statsConfig[item.platform?.name]?.leftSection?.color
                        ">
                      <img class="w-8 h-8 xl:w-6 xl:h-6" [src]="$safeNavigationMigration(statsConfig[item.platform?.name]?.leftSection?.icon)"
                        [alt]="$safeNavigationMigration(item?.platform?.name)" />
                      <span class="xl:text-base">{{ item.platform?.name }}</span>
                    </div>
                  </div>

                  <!-- STATS SECTION -->
                  <div
                    class="grid lg:grid-cols-4 grid-cols-2 gap-4 xl:gap-2 py-4 xl:py-2.5 [@media(max-height:620px)]:py-2 px-1 w-full">
                    @for (stat of statsConfig[item.platform?.name]?.rightSection?.stats ?? []; track $index) {
                    @if(item[stat.key] !== null && item[stat.key] !== undefined && item[stat.key] !== 'NA') {
                    <div class="flex flex-col gap-2 xl:gap-1">
                      <span
                        class="text-[#38385B] text-sm xl:text-[11px] xl:leading-tight xl:whitespace-nowrap dark:text-ink-soft">{{
                        stat.label }}</span>
                      <span class="text-[#141437] text-xl xl:text-lg font-medium dark:text-white">
                        {{ (stat.key === 'watchTime' ? convertMinToHMM(toNumber(item[stat.key])) :
                        toNumber(item[stat.key])) | number:(stat.key === 'watchTime' ? '1.2-2' : '1.0-0') }}
                      </span>
                    </div>
                    }
                    }
                  </div>

                  @if(isPlatformWiseLoading()){
                  <div class="flex items-center justify-center">
                    <app-individual-toaster></app-individual-toaster>
                  </div>
                  }
                </div>
                }
              </div>
            </div>
            }

            <!-- Loading State -->
            @if (isPlatformWiseLoading()) {
            <div
              class="bg-white/60 dark:bg-slate-800/60 h-[150px] backdrop-blur-lg border border-white/20 dark:border-slate-700/50 rounded-2xl p-12 shadow-none relative z-10 inset-0 mt-4">
              <app-individual-toaster [loaderType]="'light'"></app-individual-toaster>
            </div>
            }

            <!-- Empty State -->
            @if (!isPlatformWiseLoading() && visibleStats()?.length === 0) {
            <div
              class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-lg border border-white/20 dark:border-slate-700/50 rounded-2xl p-12 shadow-lg text-center relative z-10 mt-4">
              <div class="max-w-md mx-auto">
                <div
                  class="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-full flex items-center justify-center">
                  <svg class="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <h3 class="text-lg font-medium text-slate-900 dark:text-slate-100 mb-2">
                  No Analytics Data Found
                </h3>
                <p class="text-slate-600 dark:text-slate-400 mb-6">
                  There are no social platform statistics matching your current
                  filters. Try adjusting your search criteria or add new stats data.
                </p>
                <app-button variant="default" (buttonClick)="openPanel()" className="inline-flex items-center gap-2">
                  Add Stats
                </app-button>
              </div>
            </div>
            }
          </div>
          }

          <!-- ▸ Views Trend Across Platforms -->
          @case (SectionId.VIEWS_TREND) {
          <div class="card-bg rounded-xl p-4 relative w-full h-full">
            <div class="flex flex-wrap gap-4 items-center justify-between">
              <div class="text-xl text-[#141437] dark:text-white font-normal">
                Views Trend Across Platforms
              </div>

              <div class="flex items-center gap-4 w-full md:w-auto max-w-full min-w-0">
                <div [ngClass]="sec.colSpan === 4 ? 'overflow-hidden w-full' : 'w-full max-w-full'" class="min-w-0">
                  <div class="flex items-center gap-4 overflow-x-auto whitespace-nowrap pb-2 scrollbar-thin w-full">
                    @for (item of filteredPlatforms(); track $index) {
                    <button [disabled]="!hasPlatformData(item.label)" (click)="selectPlatformType(item)"
                      class="px-3 py-2 rounded-full cursor-pointer transition-all duration-200 text-sm"
                      [style.opacity]="!hasPlatformData(item.label) ? '0.4' : '1'" [style.cursor]="
                          !hasPlatformData(item.label) ? 'not-allowed' : 'pointer'
                        " [style.color]="
                          selectedPlatformTypeNames().includes(item?.label ?? '')
                            ? platformData[item?.label ?? ''].color
                            : isDarkTheme()
                            ? '#D4D4D8'
                            : '#38385B'
                        " [style.backgroundColor]="
                          selectedPlatformTypeNames().includes(item?.label ?? '')
                            ? platformData[item?.label ?? ''].bg
                            : isDarkTheme()
                            ? '#232327'
                            : '#F5F5F5'
                        " [style.borderWidth]="'1px'" [style.borderStyle]="
                          selectedPlatformTypeNames().includes(item?.label ?? '')
                            ? 'solid'
                            : 'dashed'
                        " [style.borderColor]="
                          selectedPlatformTypeNames().includes(item?.label ?? '')
                            ? platformData[item?.label ?? ''].bg
                            : isDarkTheme()
                            ? '#7979CA'
                            : '#BFBFC7'
                        ">
                      {{ item.label }}
                    </button>
                    }
                  </div>
                </div>
              </div>
            </div>

            @if ( selectedPlatformTypeNames().length > 0 && hasAnyChartData() ) {
            <div class="w-full h-[500px] overflow-x-auto overflow-y-hidden">
              <div [ngStyle]="{'min-width': chartMinWidth(), 'height': '100%'}">
                <app-multi-line-chart [data1]="$safeNavigationMigration(selectedPlatformsComputed()[0]?.data)"
                  [data2]="$safeNavigationMigration(selectedPlatformsComputed()[1]?.data)" [data3]="$safeNavigationMigration(selectedPlatformsComputed()[2]?.data)"
                  [data4]="$safeNavigationMigration(selectedPlatformsComputed()[3]?.data)" [data5]="$safeNavigationMigration(selectedPlatformsComputed()[4]?.data)"
                  [data6]="$safeNavigationMigration(selectedPlatformsComputed()[5]?.data)" [data7]="$safeNavigationMigration(selectedPlatformsComputed()[6]?.data)"
                  [primaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[0]?.color)"
                  [secondaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[1]?.color)"
                  [tertiaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[2]?.color)"
                  [quaternaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[3]?.color)"
                  [quinaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[4]?.color)"
                  [senaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[5]?.color)"
                  [septenaryLineColor]="$safeNavigationMigration(selectedPlatformsComputed()[6]?.color)" [valueKey]="'value'" [unit]="'month'"
                  [showYAxis]="true" [showXAxis]="true" [showXAxisGrid]="true" [xAxisShowOnlyFirstLast]="false"
                  [showAllXticks]="false" [showAllXLabels]="true" [showCircleStrokes]="false"
                  [showCircleStrokesWithStroke]="false" [strokeWithLineColor]="true" [showYAxisGrid]="false"
                  [showYAxisPath]="true" [curveType]="'curveLinear'">
                </app-multi-line-chart>
              </div>
            </div>

            <div class="flex items-center justify-center gap-2">
              @for (item of platformList; track $index) {
              @if(selectedPlatformTypeNames().includes(item?.key ?? '')) {
              <app-icon [style.color]="item?.color" [name]="'gitCommitHorizontal'"></app-icon>
              <span [style.color]="item?.color">
                {{ item?.key }}
              </span>
              } }
            </div>
            }@else {
            <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
              <svg class="w-16 h-16 mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
                </path>
              </svg>
              <p class="text-lg font-medium">No data available</p>
              <p class="text-sm mt-1">Data will appear here when available</p>
            </div>
            } @if(isPlatformWiseLoading()) {
            <app-individual-toaster></app-individual-toaster>
            }
          </div>
          }

          <!-- ▸ Overall Analytics -->
          @case (SectionId.OVERALL_ANALYTICS) {
          <div class="card-bg rounded-xl p-4 w-full h-full">
            <div class="text-[#141437] text-xl dark:text-white font-medium mb-4">
              Overall Analytics
            </div>

            <div class="grid grid-cols-1 w-full">
              <div class="card-bg p-4 rounded-xl relative w-full">
                <div class="text-xl text-[#141437] dark:text-white font-normal mb-4">
                  Cross-Platform Performance: Views vs Followers
                </div>
                <app-multi-horizontal-bar-chart [data]="multiHorizontalBarChartData()" [showXAxisLabel]="true"
                  [showYAxisLabel]="true" [showBarsValue]="true" [showXAxisGrid]="true" [showYAxisGrid]="true"
                  [leftMargin]="100"></app-multi-horizontal-bar-chart>

                @if(isDonutChartLoading()){
                <app-individual-toaster></app-individual-toaster>
                }
              </div>
            </div>

          </div>
          }

          <!-- ▸ Watch Time (standalone)
                Split-out variant of the "Watch Time Contribution (Top 3)"
                sub-chart inside OVERALL_ANALYTICS so it can be reordered,
                resized, and pinned to My Dashboard on its own. Reuses the
                same `topThreeWatchTimeData()` signal feeding the embedded
                chart above. -->
          @case (SectionId.WATCH_TIME) {
          <div class="card-bg rounded-xl p-4 relative w-full h-full [@media(max-height:620px)]:h-[320px]">
            <div class="text-xl text-[#141437] dark:text-white font-normal mb-4">
              Watch Time Contribution (Top 3)
            </div>
            @if(!isDonutChartLoading() && topThreeWatchTimeData().length > 0){
            <div class="w-full h-[350px] [@media(max-height:620px)]:h-[250px]">
              <app-watch-time-chart [data]="topThreeWatchTimeData()" [showXAxisLabel]="true" [showYAxisLabel]="true"
                [showBarsValue]="true" [showXAxisGrid]="true" [showYAxisGrid]="true" [leftMargin]="100">
              </app-watch-time-chart>
              <span
                class="absolute text-[#38385B] dark:text-ink-soft text-sm bottom-1 left-1/2 transform -translate-x-1/2 -translate-y-1/2">Watch
                Time (Hours)</span>
            </div>
            } @else {
            <div class="flex flex-col items-center justify-center h-full py-12 text-gray-500">
              <svg class="w-16 h-16 mb-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4">
                </path>
              </svg>
              <p class="text-lg font-medium">No data available</p>
              <p class="text-sm mt-1">Data will appear here when available</p>
            </div>
            } @if(isDonutChartLoading()){
            <app-individual-toaster></app-individual-toaster>
            }
          </div>
          }

          <!-- ▸ Follow by Platform (standalone)
                Split-out variant of the "Followers by Platform" donut inside
                OVERALL_ANALYTICS. Reuses the same `donutData()` signal. -->
          @case (SectionId.FOLLOW_BY_PLATFORM) {
          <div class="card-bg rounded-xl p-4 relative w-full h-full [@media(max-height:620px)]:h-[320px]">
            <div class="text-xl text-[#141437] dark:text-white font-normal">
              Followers by Platform
            </div>
            <div class="flex items-center justify-center h-full">
              <app-donut-chart [data]="donutData()" [showLegend]="true" [legendPosition]="donutLegendPosition()"
                [width]="donutWidth()" [height]="donutHeight()" [radiusScale]="donutRadiusScale()"
                [translateX]="0"></app-donut-chart>
            </div>
            @if(isDonutChartLoading()){
            <app-individual-toaster></app-individual-toaster>
            }
          </div>
          }

          }
        </div>
        }
      </div>

      <!-- ▸ Audit Log (standalone)
          Rendered outside the customizable 12-col grid so it is NOT part of
          the drag-drop / Customize Layout editor or the Custom Dashboard
          pin flow. Lives on the analytics view only.
          Hidden in `mixedMode` (when this component is embedded inside the
          My Dashboard / Custom Dashboard unified grid) — the audit trail is
          a page-local diagnostic surface and should not appear alongside
          the user's pinned widgets. -->
      @if (!mixedMode()) {
      <div class="mt-4">
        <app-audit-log-panel [entityType]="auditEntityTypes" [productPid]="productPid()" [showProductFilter]="false"
          title="Social Platform Audit Trails">
        </app-audit-log-panel>
      </div>
      }
      } @if(view == 'tableView'){

      <div class="mt-4 relative z-30">
        <div class="card-bg rounded-2xl p-6">
          <div class="flex flex-col lg:flex-row gap-4">
            <!-- Platform Filter -->
            <div class="flex-1 relative z-30">
              <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Filter by Platform
              </label>
              <app-dropdown [options]="platformOptions()" selectionMode="single" placeholder="Select a platform"
                [fullWidth]="true" (selectionChange)="onPlatformFilter($event)" class="w-full relative z-50" />
            </div>

            <!-- Date Range Filter -->
            <div class="flex-1 relative z-20">
              <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                Filter by Date Range
              </label>
              <app-dropdown #dateDropdown [minYear]="2017" type="datepicker" size="md" [fullWidth]="true"
                [isApplyButtonShown]="true" (selectionChange)="onDateFilter($event)" class="w-full relative z-50" />
            </div>

            <!-- Clear Filters Button -->
            <div class="flex items-end relative z-10">
              <app-button variant="secondary" (buttonClick)="clearAllFilters()"
                className="px-4 py-2 text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 border border-slate-300 dark:border-slate-600 hover:border-slate-400 dark:hover:border-slate-500 rounded-xl transition-all duration-200">
                Clear Filters
              </app-button>
            </div>
          </div>
        </div>
      </div>

      @if (isLoading()) {
      <div
        class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-lg border border-white/20 dark:border-slate-700/50 rounded-2xl p-12 shadow-lg relative z-10 mt-4">
        <div class="flex items-center justify-center">
          <div class="flex items-center gap-3">
            <div class="w-6 h-6 border-3 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <span class="text-slate-600 dark:text-slate-400 font-medium">Loading analytics data...</span>
          </div>
        </div>
      </div>
      } @if (!isLoading() && processedStatsData().length > 0) {
      <div class="card-bg rounded-2xl overflow-hidden relative z-10 mt-4">
        <div
          class="px-6 py-4 bg-gradient-to-r from-slate-50/50 to-blue-50/50 dark:from-slate-700/50 dark:to-slate-600/50 border-b border-slate-200/50 dark:border-slate-600/50">
          <h2 class="text-lg font-medium text-slate-800 dark:text-slate-200">
            Platform Performance Statistics
          </h2>
          <p class="text-sm text-slate-600 dark:text-slate-400 mt-1">
            {{ totalItems() }} total records found
          </p>
        </div>
        <div class="p-4">
          @if(processedStatsData().length > 0){
          <app-paginated-table [tableData]="processedStatsData()" [headers]="tableHeaders" [isCheckboxShow]="false"
            [tableActionOptions]="{
              showToggleButton: true,
              toggleOptions: tableActionOptions
            }" (actionSelected)="selectedRowItem($event)" />
          }
        </div>
      </div>
      } @if (!isLoading() && processedStatsData().length === 0) {
      <div
        class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-lg border border-white/20 dark:border-slate-700/50 rounded-2xl p-12 shadow-lg text-center relative z-10">
        <div class="max-w-md mx-auto">
          <div
            class="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <h3 class="text-lg font-medium text-slate-900 dark:text-slate-100 mb-2">
            No Analytics Data Found
          </h3>
          <p class="text-slate-600 dark:text-slate-400 mb-6">
            There are no social platform statistics matching your current filters.
            Try adjusting your search criteria or add new stats data.
          </p>
          <app-button variant="default" (buttonClick)="openPanel()" className="inline-flex items-center gap-2">
            Add Stats
          </app-button>
        </div>
      </div>
      } }

      <!-- Error Message -->
      <!-- @if (errorMessage()) {
      <div class="mb-6">
        <app-alert
          [message]="errorMessage()"
          [duration]="5000"
          [type]="'error'"
          [closable]="true"
          [showProgress]="true"
          (close)="errorMessage.set('')"
        />
      </div>
      } -->
      <!-- Audit Logs are rendered as a standalone block right below the
          analytics-view customizable grid (see above). They are intentionally
          NOT part of the drag-drop Customize Layout editor or the Custom
          Dashboard pin flow. -->
    </div>
  </div>
  <!-- </ng-container> -->
  <div class="bg-white dark:bg-surface-1" [class.hidden]="_breakpointService.isDesktop()">
    <app-social-platform-mobile [startDate]="selectedStartRange" [endDate]="selectedEndRange" [view]="view"
      [tabOptions]="tabOptions" [cardStatsConfig]="cardStatsConfig()" [isOverallLoading]="isOverallLoading()"
      [isPlatformWiseLoading]="isPlatformWiseLoading()" [isDonutChartLoading]="isDonutChartLoading()"
      [isLoading]="isLoading()" [platformItemsData]="mobilePlatformItems()" [filteredPlatforms]="filteredPlatforms()"
      [selectedPlatformTypeNames]="selectedPlatformTypeNames()" [selectedPlatforms]="selectedPlatformsComputed()"
      [hasAnyChartData]="hasAnyChartData()" [platformList]="platformList"
      [multiHorizontalBarChartData]="multiHorizontalBarChartData()" [topThreeWatchTimeData]="topThreeWatchTimeData()"
      [donutData]="donutData()" [platformOptions]="platformOptions()" [processedStatsData]="processedStatsData()"
      [tableHeaders]="tableHeaders" [tableActionOptions]="tableActionOptions" [totalItems]="totalItems()"
      [predefinedRanges]="predefinedRanges" [selectedStartRange]="selectedStartRange"
      [selectedEndRange]="selectedEndRange" (openPanelRequested)="openPanel()" (viewChanged)="setActiveTab($event)"
      (dateRangeChanged)="onDateRangeFilter($event)" (platformTypeSelected)="selectPlatformType($event)"
      (platformFilterChanged)="onPlatformFilter($event)" (dateFilterChanged)="onDateFilter($event)"
      (clearFiltersRequested)="clearAllFilters()" (tableActionSelected)="selectedRowItem($event)">
    </app-social-platform-mobile>
  </div>
  <!--  Customize Popup Layout — Mini-Dashboard Editor.
        Inline overlay that visually mirrors the actual social-platform
        sections. Tiles support drag-drop reordering, width resizing
        (4 / 6 / 8 / 12 chips), and visibility toggling — applied to the
        live page when the user hits Apply. -->
  <!-- ═════════════════════════════════════════════════════════════════════════ -->
  @if (isLayoutEditorOpen()) {
  <!-- z-[10000] sits above the global navbar/sidebar (which use z-[999]) so the popup never gets clipped by the dashboard header. Extra top padding gives breathing room from the page top. -->
  <div appLayoutEditorOverlay
    class="fixed inset-0 z-[10010] flex items-center justify-center p-3 sm:p-6 bg-slate-900/60 backdrop-blur-sm animate-fadeIn overflow-hidden"
    (click)="closeLayoutEditor()">

    <div
      class="layout-editor-popup relative w-full max-w-[1100px] max-h-[min(88vh,calc(100vh-2rem))] flex flex-col bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-700 overflow-hidden"
      (click)="$event.stopPropagation()">

      <!--  Header -->
      <div
        class="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-[#AD46FF]/5 via-white to-[#AD46FF]/5 dark:from-purple-500/10 dark:via-slate-900 dark:to-purple-500/10">
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-10 h-10 rounded-xl bg-gradient-to-br from-[#AD46FF] to-[#7c3aed] flex items-center justify-center shadow-lg shadow-[#AD46FF]/30 shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <rect width="7" height="9" x="3" y="3" rx="1" />
              <rect width="7" height="5" x="14" y="3" rx="1" />
              <rect width="7" height="9" x="14" y="12" rx="1" />
              <rect width="7" height="5" x="3" y="16" rx="1" />
            </svg>
          </div>
          <div class="min-w-0">
            <h2 class="text-lg sm:text-xl font-semibold text-[#141437] dark:text-white truncate">
              Customize Layout
            </h2>
            <p class="text-[11px] text-violet-700 dark:text-violet-300">
              <b>Drag</b> a card to reorder &middot; click the <b>width chips</b> to resize &middot; toggle the
              <b>eye</b> to hide/show &middot; the preview mirrors the real dashboard.
            </p>
          </div>
        </div>

        <div class="flex items-center gap-2.5 flex-wrap">
          <!-- Auto Adjust Width: expands the smallest card in each row of
               the preview so any leftover columns are filled. -->
          <button type="button" (click)="autoAdjustEditorWidths()" [disabled]="!canAutoAdjustEditorWidths()"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
            [ngClass]="canAutoAdjustEditorWidths()
              ? 'bg-white dark:bg-slate-800 text-[#AD46FF] border border-[#AD46FF]/30 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 shadow-sm cursor-pointer'
              : 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 cursor-not-allowed'"
            title="Expand the smallest card in each row to fill the leftover columns">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 3 21 3 21 9" />
              <polyline points="9 21 3 21 3 15" />
              <line x1="21" y1="3" x2="14" y2="10" />
              <line x1="3" y1="21" x2="10" y2="14" />
            </svg>
            Auto Adjust Width
          </button>

          <!-- Visible count chip -->
          <span
            class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-violet-50 dark:bg-violet-500/10 text-[#AD46FF] border border-[#AD46FF]/20">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            {{ editorVisibleCount() }} / {{ editorItems().length }} visible
          </span>

          <!-- Close -->
          <button type="button" (click)="closeLayoutEditor()"
            class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
            title="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Layout Preview Area (mini dashboard editor) -->
      <div class="flex-1 overflow-y-auto custom-scroll bg-[#FAFAFE] dark:bg-slate-950/40 p-3 sm:p-4">

        <!-- 12-col mini grid: cdkDropList enables drag-drop reordering;
             tile widths come from `getEditorColSpanClass(item.colSpan)`. -->
        <div cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onEditorCardDrop($event)"
          class="grid grid-cols-12 gap-2 sm:gap-2.5 grid-flow-row-dense">

          @for (item of editorItems(); track trackEditorItem($index, item)) {
          <div cdkDrag cdkDragBoundary=".layout-editor-popup" [cdkDragData]="item" [cdkDragDisabled]="!item.visible" [ngClass]="[
              getEditorColSpanClass(item.colSpan),
              item.visible
                ? 'border-slate-200 dark:border-slate-700 shadow-sm hover:shadow-lg hover:-translate-y-0.5 hover:border-[#AD46FF]/40 cursor-grab active:cursor-grabbing'
                : 'border-dashed border-slate-300 dark:border-slate-600 opacity-60 cursor-not-allowed'
            ]"
            class="layout-editor-tile group relative rounded-xl border bg-white dark:bg-slate-800 transition-all duration-200 overflow-hidden">

            <!-- Drop placeholder (highlight slot during drag) -->
            <div *cdkDragPlaceholder [ngClass]="getEditorColSpanClass(item.colSpan)"
              class="rounded-xl border-2 border-dashed border-[#AD46FF]/60 bg-violet-50 dark:bg-violet-500/10 min-h-[88px]">
            </div>

            <!-- Tile header: drag handle + title + visibility toggle -->
            <div class="flex items-start justify-between gap-2 px-2.5 pt-2 pb-1">
              <div class="flex items-center gap-1.5 min-w-0">
                <span class="text-slate-300 dark:text-slate-600 group-hover:text-[#AD46FF] transition-colors shrink-0"
                  title="Drag to reorder">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"
                    stroke="none">
                    <circle cx="9" cy="5" r="1" />
                    <circle cx="9" cy="12" r="1" />
                    <circle cx="9" cy="19" r="1" />
                    <circle cx="15" cy="5" r="1" />
                    <circle cx="15" cy="12" r="1" />
                    <circle cx="15" cy="19" r="1" />
                  </svg>
                </span>
                <span class="text-[11px] sm:text-[12px] font-semibold text-[#141437] dark:text-white truncate"
                  [title]="item.title">
                  {{ item.title }}
                </span>
              </div>

              <!-- Visibility toggle -->
              <button type="button" (click)="toggleEditorCardVisibility(item.id); $event.stopPropagation()"
                class="p-1 rounded-md transition-colors shrink-0"
                [ngClass]="item.visible
                    ? 'text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                    : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700'"
                [title]="item.visible ? 'Hide section' : 'Show section'">
                @if (item.visible) {
                <app-icon-v2 name="eye" [size]="14"></app-icon-v2>
                } @else {
                <app-icon-v2 name="eye-off" [size]="14"></app-icon-v2>
                }
              </button>
            </div>

            <!-- Tile body: scaled-down preview placeholder + width chips.
                 Uniform `h-10` body (matches monthly-report-1) — the chips
                 below carry the size cue, so the body just needs enough
                 room for the abstract preview bars. -->
            <div class="px-2.5 pb-2">
              <div
                class="rounded-lg bg-gradient-to-br from-violet-50 via-white to-violet-50/50 dark:from-violet-500/10 dark:via-slate-800 dark:to-violet-500/5 border border-slate-100 dark:border-slate-700/50 h-10 sm:h-10 flex items-center justify-center mb-1.5 overflow-hidden relative">
                <!-- abstract preview bars -->
                <div class="flex items-end gap-1 w-2/3 h-1/2 opacity-70">
                  <span class="flex-1 bg-[#AD46FF]/30 rounded-sm" style="height: 40%"></span>
                  <span class="flex-1 bg-[#AD46FF]/50 rounded-sm" style="height: 70%"></span>
                  <span class="flex-1 bg-[#AD46FF]/40 rounded-sm" style="height: 55%"></span>
                  <span class="flex-1 bg-[#AD46FF]/60 rounded-sm" style="height: 90%"></span>
                  <span class="flex-1 bg-[#AD46FF]/35 rounded-sm" style="height: 50%"></span>
                  <span class="flex-1 bg-[#AD46FF]/55 rounded-sm" style="height: 80%"></span>
                </div>
                <span
                  class="absolute top-0.5 right-1 text-[9px] font-semibold text-[#AD46FF]/70 uppercase tracking-wider">
                  {{ item.colSpan }}/12
                </span>
              </div>
              <!-- Width selector — minimize-2 / maximize-2 icon buttons step
                   the card through [4 → 6 → 8 → 12] widths.
                   Buttons disable themselves at the boundary. -->
              <div class="flex items-center gap-1.5">
                <span
                  class="text-[10px] font-medium text-slate-400 dark:text-slate-500 uppercase tracking-wide mr-0.5">Width</span>

                <!-- Decrease (minimize-2) -->
                <button type="button" (click)="decreaseEditorCardColSpan(item.id); $event.stopPropagation()"
                  [disabled]="!canDecreaseEditorCardColSpan(item)" class="p-1 rounded-md border transition-all"
                  [ngClass]="canDecreaseEditorCardColSpan(item)
                    ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                    : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                  title="Decrease width">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="4 14 10 14 10 20" />
                    <polyline points="20 10 14 10 14 4" />
                    <line x1="14" y1="10" x2="21" y2="3" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>

                <!-- Current width pill — Small / Medium / Large / Full -->
                <span
                  class="inline-flex items-center justify-center min-w-[58px] h-[20px] px-2 rounded-md text-[10px] font-semibold bg-[#AD46FF]/10 text-[#AD46FF] border border-[#AD46FF]/20 select-none whitespace-nowrap">
                  {{ getEditorColSpanLabel(item.colSpan) }}
                </span>

                <!-- Increase (maximize-2) -->
                <button type="button" (click)="increaseEditorCardColSpan(item.id); $event.stopPropagation()"
                  [disabled]="!canIncreaseEditorCardColSpan(item)" class="p-1 rounded-md border transition-all"
                  [ngClass]="canIncreaseEditorCardColSpan(item)
                    ? 'bg-white dark:bg-slate-700 text-slate-500 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-[#AD46FF]/50 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5'
                    : 'bg-slate-50 dark:bg-slate-800 text-slate-300 dark:text-slate-600 border-slate-100 dark:border-slate-700 cursor-not-allowed'"
                  title="Increase width">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 3 21 3 21 9" />
                    <polyline points="9 21 3 21 3 15" />
                    <line x1="21" y1="3" x2="14" y2="10" />
                    <line x1="3" y1="21" x2="10" y2="14" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          }
        </div>

        @if (editorItems().length === 0) {
        <div class="text-center py-16 text-slate-500 dark:text-slate-400">
          <p class="text-sm">No layout items to customize.</p>
        </div>
        }
      </div>

      <!-- ▶ Footer -->
      <div
        class="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
        <button type="button" (click)="resetLayoutEditorToDefaults()"
          class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-300 hover:text-[#AD46FF] hover:bg-violet-50 dark:hover:bg-white/5 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
          </svg>
          Set Default
        </button>

        <div class="flex items-center gap-2">
          <button type="button" (click)="closeLayoutEditor()"
            class="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors">
            Cancel
          </button>
          <button type="button" (click)="applyLayoutEditor()" [disabled]="editorVisibleCount() === 0"
            class="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-[#AD46FF] to-[#7c3aed] hover:shadow-lg hover:shadow-[#AD46FF]/30 hover:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 transition-all">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
  }

  @if (panelOpen()) {
  <app-slide-panel [open]="panelOpen()" [title]="isEdit() ? 'Update Stats' : 'Add New Stats'" (closed)="closePanel()"
    class="flex-1 text-[#141437] dark:text-white"
    panelClass="min-w-[600px] max-w-[800px] w-fit h-full flex flex-col overflow-hidden card-bg">
    <form [formGroup]="form" (ngSubmit)="submitForm()" class="flex flex-col flex-1 overflow-hidden h-full">
      <section class="flex flex-col gap-4 flex-1 overflow-y-auto pr-1 py-2">
        <div class="text-slate-700 dark:text-slate-300 w-full flex flex-col gap-1 relative">
          <app-dropdown [minYear]="2017" [maxYear]="currentYear" [maxMonth]="currentMonth" type="datepicker"
            [iconName]="'calendar'" variant="themeBase" [selectedValue]="$safeNavigationMigration(form.get('dateReference')?.value)"
            formControlName="dateReference" [error]="getErrorMessage('dateReference')"
            placeholder="Select Month & Year"></app-dropdown>
        </div>
        <div class="text-slate-700 dark:text-slate-300 w-full flex flex-col gap-1">
          <div class="grid grid-cols-4 items-center gap-2 flex-wrap">
            @for(item of filteredPlatforms(); track $index){

            <button (click)="selectPlatform(item)" [ngClass]="
                item?.value === selectedPlatform()
                  ? 'bg-[#AD46FF] text-[#FFFFFF] border-[#AD46FF]'
                  : 'bg-transparent text-[#38385B] dark:text-ink-soft border-[#EAEAEA] dark:border-line'
              " type="button" variant="primary"
              class="p-2 border text-[14px] transition-colors duration-200 rounded-full cursor-pointer">
              {{ item?.label }}
            </button>
            }
          </div>
        </div>

        <div [style.background]="
            isDarkTheme()
              ? statsConfig[selectedPlatformName()]?.leftSection?.bgDark
              : statsConfig[selectedPlatformName()]?.leftSection?.bgLight
          " class="grid grid-cols-1 gap-4 bg-red-400 p-4 rounded-2xl mt-2">
          <div class="flex flex-col items-center gap-2">
            <img class="w-10 h-10" [src]="$safeNavigationMigration(statsConfig[selectedPlatformName()]?.leftSection?.icon)" alt="" />
            <span>
              {{ statsConfig[selectedPlatformName()]?.leftSection?.label }}
            </span>
          </div>

          <div class="relative group" *ngFor="let field of selectedPlatformFields">
            <div *ngIf="field.control === 'watchTime'" class="absolute right-0 -top-1 z-10">
              <mat-slide-toggle class="small-toggle" [checked]="watchTimeMode()"
                (change)="toggleTimeMode($event, field)">
              </mat-slide-toggle>
            </div>

            <app-input variant="custom" type="text" inputmode="decimal" [placeholder]="'Enter ' + field.label"
              [label]="field.label" [formControlName]="field.control" [error]="getErrorMessage(field.control)">
            </app-input>

            <button type="button"
              *ngIf="$safeNavigationMigration(form.get(field.control)?.value) !== null && form.get(field.control)?.value !== ''"
              (click)="form.get(field.control)?.setValue(null)"
              class="absolute right-3 top-[36px] text-slate-400 hover:text-red-500 transition-colors duration-200"
              title="Clear field">
              <app-icon name="circleX" [size]="16"></app-icon>
            </button>
          </div>
        </div>
      </section>

      @if(errorMessage()) {
      <app-alert [message]="errorMessage()" [duration]="5000" [type]="'error'" [closable]="true" [showProgress]="true"
        (close)="errorMessage.set('')"></app-alert>
      } @if(successMessage()) {
      <app-alert [message]="successMessage()" [duration]="3000" [type]="'success'" [closable]="true"
        [showProgress]="true" (close)="successMessage.set('')"></app-alert>
      }

      <div class="grid grid-cols-2 gap-3 p-4 sticky bottom-0 border-t border-[#EAEAEA] dark:border-line mt-3">
        <app-button type="button" variant="defaultBorder" (buttonClick)="clearForm()"
          className="w-full">Cancel</app-button>
        <app-button type="submit" variant="default" className="w-full" [disabled]="isSubmitDisabled()">
          {{ isEdit() ? "Update" : "Submit" }}
        </app-button>
      </div>
    </form>
  </app-slide-panel>
  }
</ng-container>